import { ApiResponse, QuotationRequest, QuotationResponse } from '../types/api';
import { ENCRYPTION_CONFIG } from '../constants';
import { encryptApplicantsIdNo } from '../../utils/crypto';
import { lifeApi } from './base';

const postQuickQuotation = lifeApi.injectEndpoints({
  endpoints: (builder) => ({
    postQuickQuotation: builder.mutation<
      ApiResponse<QuotationResponse>,
      QuotationRequest
    >({
      queryFn: async (body, _queryApi, _extraOptions, baseQuery) => {
        const encryptedApplicants = await encryptApplicantsIdNo(
          body.applicants,
          ENCRYPTION_CONFIG,
        );

        const encryptedBody: QuotationRequest = {
          ...body,
          applicants: encryptedApplicants,
        };

        const result = await baseQuery({
          url: '/',
          params: {
            relativeUrl: 'quotations',
          },
          method: 'POST',
          body: encryptedBody,
        });

        return result.data
          ? { data: result.data as ApiResponse<QuotationResponse> }
          : { error: result.error };
      },
    }),
  }),
});

export const { usePostQuickQuotationMutation } = postQuickQuotation;
